module.exports = __webpack_public_path__ + "img/15.e36724b9.jpg";